import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-baojiadan",
  "use": "icon-baojiadan-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-baojiadan\"><g fill-rule=\"nonzero\"><path d=\"M11.167 4.667H5.5a.513.513 0 01-.5-.5c0-.267.233-.5.5-.5h5.667c.266 0 .5.233.5.5 0 .266-.234.5-.5.5zm0 3.666H5.5a.513.513 0 01-.5-.5c0-.266.233-.5.5-.5h5.667c.266 0 .5.234.5.5 0 .267-.234.5-.5.5zm-2 3.667H5.5a.513.513 0 01-.5-.5c0-.267.233-.5.5-.5h3.667c.266 0 .5.233.5.5s-.234.5-.5.5zm3.233 2.633H11v-.766h1.4v-.634H11V12.5h.833L11 10.967h1l.867 1.5.833-1.5h.933L13.8 12.5h.867v.733h-1.334v.634h1.334v.766h-1.334v1.034H12.4v-1.034z\" /><path d=\"M9.333 15.667h-6.5c-1 0-1.833-.834-1.833-1.834V2.167c0-1 .833-1.834 1.833-1.834h10.334c1 0 1.833.834 1.833 1.834V9c0 .267-.233.5-.5.5A.513.513 0 0114 9V2.167a.825.825 0 00-.833-.834H2.833A.825.825 0 002 2.167v11.666c0 .467.367.834.833.834h6.5c.267 0 .5.233.5.5 0 .266-.233.5-.5.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/baojiadan.svg
// module id = 447
// module chunks = 4